export default "__VITE_ASSET__0pkaGrzX__"